import type { OrgStatusResponse } from '@/api/organizations'

/** O usuário precisa se vincular a uma Organização: não tem vínculo e o
 *  servidor não o isentou (`org_required`). Única regra usada pelo gate e pelo
 *  wizard de setup — fora de `@/api/organizations` para não sumir quando os
 *  testes mockam aquele módulo inteiro. */
export function precisaEscolherOrganizacao(status: OrgStatusResponse): boolean {
  return status.has_org === false && status.org_required !== false
}
